import React, { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import QRCode from "react-qr-code";
import axios from 'axios';
import GConf from '../AssetsM/generalConf';
import { Button } from 'semantic-ui-react';


function ShowSeanceData() {
    let ProfData = JSON.parse(localStorage.getItem("ProfData"));
    let {ids,groupe} = useParams()
    let [refreshListe, setRefreshList] = useState(false)
    let [presenceListe, setPresenceListe] = useState([])
    let [etudiantListe, setEtudiantListe] = useState([])
    let [seanceFerme, setSeanceFerme] = useState(false)
    let [finalEtudiantList, setFinalEtudiantListe] = useState([])

    useEffect(() => {
        const inputIsLogged = JSON.parse(localStorage.getItem('ProfData'));
        if (!inputIsLogged) {window.location.href = "/Admin/logIn";}
         
        axios.post(`${GConf.ApiLink}/etudiant/select-list-by-groupe`, {
            e_groupe :  groupe,
        })
        .then(function (response) {
             setEtudiantListe(response.data)
             
        })

        axios.post(`${GConf.ApiLink}/proff/seance/info`, {
            ids :  ids,
        })
        .then(function (response) {
             if (response.data[0].s_etat == "Fermee") { setSeanceFerme(true)}
        })

        
    },[])

    useEffect(() => {
        axios.post(`${GConf.ApiLink}/proff/seance/select-all-presences`, {
            ids :  ids,
        })
        .then(function (response) {
             setPresenceListe(response.data)
        })
    },[refreshListe])

    const Presence = etudId => {
        const found = presenceListe.find(data => data.ide === String(etudId));
             return !!found;
    };

    const FermerLaSeanceFunction = () => {
        let prl = []
        etudiantListe.map((data, index) => prl.push({id:index, etuId : data.ide, etuNom: data.e_nom, present: Presence(data.ide)}))
         

        axios.post(`${GConf.ApiLink}/proff/seance/fermer-presence`, {
            ids : ids,
            s_presence : prl,
            s_statistique : ((presenceListe.length / etudiantListe.length)*100).toFixed(2),
        })
        .then(function (response) {
              console.log(response.data)
              console.log(response.status)
              if (response.status == 200 ) {
                alert('Seance Fermeé')
                setSeanceFerme(true)
              }
        })

    }

    const MainTopCard = () =>{
            return(<>
                <div className='card p-3 fixed-top border-0 shadow-sm  rounded-0'>
                    <div className='row'>
                        <div className='col-4 align-self-center'>
                            <NavLink exact='true' to='/Proff/L'>
                                <span className='bi bi-arrow-left-short bi-md text-primary'></span>
                            </NavLink>
    
                        </div>
                        <div className='col-8 align-self-center text-end' ><h2> <span className="badge bg-info"> <span className='bi bi-person '></span>  {ProfData.p_nom}  </span></h2></div>
                        
                    </div>
                </div>
            </>)
    }

    const PresenceCard = (props) => {
        

        return(<>
        <div className='card p-2 mb-2 shadow-sm border-div'>
            <div className='row'>
                <div className='col-10 align-self-center'>{props.data.e_nom} </div>
                <div className='col-2'><span className={`bi bi-circle-fill bi-sm ${Presence(props.data.ide) ? 'text-present' : 'text-not-present'}  `}></span></div>
            </div>
        </div>
        </>)
    }

    return ( <>
      
            <MainTopCard />
            <br />                
            <br />                
            <br />                
            <br />   
                   
            <div className='container'>
                 <div className={`row  ${seanceFerme ? 'opacity-50 pe-none' :''} `}>
                    <div className="col-12 col-lg-6 border-end">
                        <div className='card border-0 bg-transparent d-flex justify-content-center align-items-center'>
                        <QRCode fgColor="#" value={ids} size={420} />
                        
                        </div>
                        <div className='card mb-1 mt-4'>
                            <h1 className='text-center'>{ids}</h1>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                            <div className='row'>
                                <div className="col-12 col-lg-6"><Button className='mb-2 bg-warning' onClick={() => setRefreshList(!refreshListe)}>Actualzer la liste </Button></div>
                                <div className="col-12 col-lg-6 text-end"><Button className='mb-2 bg-danger text-white' onClick={() => FermerLaSeanceFunction()}> Fermer la seance  </Button></div>
                            </div>
                            
                            {etudiantListe.map((data,index) => <PresenceCard key={index} data={data} />)}
                    </div>
                 </div>
                     
            </div>

    </> );
}

export default ShowSeanceData;